import { assertTypeType } from "./util";
assertTypeType();
